<template>
  <Table.Headers class="group">
    <Table.HeaderCheckbox
      v-if="showCheckbox"
      v-slot="{ checked, indeterminate }"
    >
      <Checkbox
        :size="22"
        :model-value="checked"
        :indeterminate="indeterminate"
        class="tablet-h:invisible tablet-h:group-hover:visible"
        :class="checkboxClasses"
      />
    </Table.HeaderCheckbox>
    <Table.Header class="cursor-pointer" @click="$emit('sort', 'name')">
      Name
      <Icon
        v-if="isSort('name')"
        name="ArrowUp"
        :size="12"
        class="stroke-gray-800 ml-2"
        :class="headerIconClasses"
      />
    </Table.Header>
    <Table.Header
      class="hidden tablet-h:flex w-[250px] cursor-pointer"
      @click="$emit('sort', 'timestamp')"
    >
      Dacr Timestamp
      <Icon
        v-if="isSort('timestamp')"
        name="ArrowUp"
        :size="12"
        class="stroke-gray-800 ml-2"
        :class="headerIconClasses"
      />
    </Table.Header>
    <Table.Header class="hidden tablet-h:flex w-[200px]"> Status </Table.Header>
    <Table.Header class="tablet-h:hidden">
      <div
        class="w-4 h-4 border border-gray-800 rounded-sm flex items-center justify-center p-0.5 cursor-pointer"
        :class="checkboxIconClasses"
        @click="$emit('toggleCheckbox')"
      >
        <Icon name="Check" />
      </div>
    </Table.Header>
  </Table.Headers>
</template>

<script setup lang="ts">
import { Table, Checkbox, Icon } from '@dacr/ui'
import type { ComputedRef } from 'vue'

defineProps<{
  showCheckbox: boolean
  checkboxClasses: Record<string, boolean>
  checkboxIconClasses: Record<string, boolean>
  headerIconClasses:
    | ComputedRef<Record<string, boolean>>
    | Record<string, boolean>
  isSort: (value: string) => boolean
}>()

defineEmits<{
  sort: [key: string]
  toggleCheckbox: []
}>()
</script>
